// extracted by mini-css-extract-plugin
export var chevron = "_1y-d";
export var disabled = "_1y-b";
export var error = "_1y-c";
export var hideBorder = "_1y-1";
export var icon = "_1y-e";
export var input = "_1y-0";
export var large = "_1y-f";
export var open = "_1y-9";
export var placeholder = "_1y-a";
export var regular = "_1y-5";
export var singleRowInput = "_1y-2";
export var singleSelectInput = "_1y-3 _1y-0";
export var small = "_1y-4";
export var spinnerContainer = "_1y-i";
export var tag = "_1y-7";
export var tagsContainer = "_1y-8";
export var tagsInput = "_1y-6 _1y-0";
export var xSmall = "_1y-g";
export var xxSmall = "_1y-h";